import classes from "./contact.module.css";

const ContactIntro = () => {
  return (
    <>
      <div className={classes.introContainer}>
        <p className={classes.HeadLine}>
          <span>Hey I'm Vivek Sharma </span>
          somewhere between clean logic and elegant interfaces — that's where
          the work speaks.
        </p>

        <p className={classes.IntroPara}>
          Building digital experiences that just make sense has been a quiet
          obsession — from crafting APIs to designing intuitive frontends.
        </p>

        <p className={classes.IntroPara}>
          {" "}
          It’s less about job titles, more about solving real problems with code
          that scales and UI that feels natural.
        </p>

        <p className={classes.IntroPara}>
          Currently contributing to product and backend development at an
          ed-tech platform, experimenting with Node.js, React, Next.js, and the
          occasional AWS challenge.
        </p>
        <p className={classes.IntroPara}>
          Every project is an opportunity to blend performance with precision —
          and I tend to stick around where things are being built from the
          ground up.
        </p>
      </div>
    </>
  );
};

export default ContactIntro;
